"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toContactListSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toContactListSlice = function (data, logger) {
    var _a, _b, _c, _d;
    var title = logger.required(fields_1.toText((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.title));
    var contacts = [
        fields_1.toDocumentLink((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.contact1, logger),
        fields_1.toDocumentLink((_c = data === null || data === void 0 ? void 0 : data.primary) === null || _c === void 0 ? void 0 : _c.contact2, logger),
        fields_1.toDocumentLink((_d = data === null || data === void 0 ? void 0 : data.primary) === null || _d === void 0 ? void 0 : _d.contact3, logger),
    ].filter(Boolean);
    var contact_block_1 = getBlock1(data, logger);
    var contact_block_2 = getBlock2(data);
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.ContactList)), { title: title,
        contacts: contacts, block_1: contact_block_1, block_2: contact_block_2 }));
};
exports.toContactListSlice = toContactListSlice;
var getBlock1 = function (data, logger) {
    var blockData = utils_1.unprefix('block1', data.primary);
    if (blockData) {
        var image = fields_1.toImage(blockData.image, logger);
        var title = fields_1.toText(blockData.title);
        var mail = fields_1.toText(blockData.mail);
        var mail_color = toMailColor(blockData.mailColor);
        return utils_1.compact({
            image: image,
            title: title,
            mail: mail,
            mail_color: mail_color
        });
    }
};
var getBlock2 = function (data) {
    var blockData = utils_1.unprefix('block2', data.primary);
    if (blockData) {
        var text = fields_1.toText(blockData.text);
        var mail = fields_1.toText(blockData.mail);
        var mail_color = toMailColor(blockData.mailColor);
        return utils_1.compact({
            text: text,
            mail: mail,
            mail_color: mail_color
        });
    }
};
var toMailColor = function (color) {
    switch (color) {
        case 'Jaune':
            return 'yellow';
        case 'Blanc':
            return 'white';
        default:
            return 'yellow';
    }
};
//# sourceMappingURL=contact-list-slice.js.map